import {autoinject, bindable, bindingMode, customElement} from 'aurelia-framework';
import {allCountries, Country} from "../models";

@customElement('address-form')
@autoinject
export class AddressForm {
  @bindable({defaultBindingMode: bindingMode.twoWay}) address: Address;
  @bindable({defaultBindingMode: bindingMode.twoWay}) valid: boolean;

  formErrors: FormErrors = new FormErrors();
  countries: Array<Country>;

  constructor() {
    this.countries = allCountries;
  }

  addressChanged(newAddress: Address, oldAddress: Address) {
    this.validateInput();
  }

  private validateInput() {
    let valid = true;
    let formErrors = new FormErrors();
    let plzRegEx = new RegExp(/[0-9]{5}/);
    const emailRegEx = new RegExp(/[\w+-]+(?:\.[\w+-]+)*@[\w+-]+(?:\.[\w+-]+)*\.[a-zA-Z]{2,17}/);

    if (!this.address.first_name || this.address.first_name === '') {
      formErrors.nameErrorMessage = "Gib bitte deinen Vornamen an";
      valid = false;
    }

    if (!this.address.last_name || this.address.last_name === '') {
      formErrors.lastnameErrorMessage = "Gib bitte deinen Nachnamen an";
      valid = false;
    }

    if (!emailRegEx.test(this.address.e_mail)) {
      formErrors.emailErrorMessage = "Gib bitte eine korrekte E-Mail Adresse an";
      valid = false;
    }

    if (!this.address.street || this.address.street === '') {
      formErrors.streetErrorMessage = "Gib bitte deine Straße & Hausnummer an";
      valid = false;
    }

    // austria does only have 4 digits for zip code
    if (this.address.country === "AT") {
      plzRegEx = new RegExp(/[0-9]{4}/);
    }

    if (!plzRegEx.test(this.address.zip)) {
      formErrors.zipErrorMessage = "Gib bitte eine korrekte PLZ an";
      valid = false
    }

    if (!this.address.city || this.address.city === '') {
      formErrors.cityErrorMessage = "Gib bitte deine Stadt an";
      valid = false;
    }

    if (!this.address.country) {
      formErrors.countryErrorMessage = "Bitte wähle ein Land aus!";
      valid = false;
    }

    this.formErrors = formErrors;
    this.valid = valid;
  }
}

export class Address {
  first_name: string;
  last_name: string;
  street: string;
  e_mail: string;
  city: string;
  zip: string;
  country: string;
}

export class FormErrors {
  countryErrorMessage: string;
  zipErrorMessage: string;
  nameErrorMessage: string;
  lastnameErrorMessage: string;
  emailErrorMessage: string;
  streetErrorMessage: string;
  cityErrorMessage: string;
}